import { lazy, Suspense } from 'react';
import { Home } from './pages/Home';
import { normalizeRoomCode } from './lib/api';
import { usePathname } from './lib/router';

// The call UI (LiveKit SDK) is most of the bundle; the home page shouldn't wait for it.
const RoomPage = lazy(() => import('./pages/Room').then((m) => ({ default: m.RoomPage })));
const AdminApp = lazy(() => import('./admin/AdminApp').then((m) => ({ default: m.AdminApp })));
const MeetingsPage = lazy(() => import('./pages/Me').then((m) => ({ default: m.MeetingsPage })));
const MeetingPage = lazy(() => import('./pages/Me').then((m) => ({ default: m.MeetingPage })));
const SettingsPage = lazy(() => import('./pages/Me').then((m) => ({ default: m.SettingsPage })));
const loading = <main className="screen center"><div className="spinner" aria-label="Загрузка" /></main>;

/** admin.meet.* serves the admin panel from the same bundle; nginx guards the host. */
const isAdminHost = typeof location !== 'undefined' && location.hostname.startsWith('admin.');

export function App() {
  const path = usePathname();
  if (isAdminHost) {
    return (
      <Suspense fallback={<main className="screen center"><div className="spinner" aria-label="Загрузка" /></main>}>
        <AdminApp />
      </Suspense>
    );
  }
  const segment = path.replace(/^\/+|\/+$/g, '');
  if (!segment) return <Home />;
  if (segment === 'me' || segment.startsWith('me/')) {
    const meeting = /^me\/meetings\/(.+)$/.exec(segment)?.[1];
    return (
      <Suspense fallback={loading}>
        {segment === 'me/settings' ? (
          <SettingsPage />
        ) : meeting ? (
          <MeetingPage callId={decodeURIComponent(meeting)} />
        ) : (
          <MeetingsPage />
        )}
      </Suspense>
    );
  }
  const code = normalizeRoomCode(segment);
  // key: switching rooms must tear down the previous connection completely.
  if (!code) return <NotFound />;
  return (
    <Suspense fallback={<main className="screen center"><div className="spinner" aria-label="Загрузка" /></main>}>
      <RoomPage key={code} code={code} />
    </Suspense>
  );
}

function NotFound() {
  return (
    <main className="screen center">
      <div className="card narrow">
        <h1>Такой встречи нет</h1>
        <p className="muted">Проверьте ссылку или создайте новую встречу.</p>
        <a className="btn primary" href="/">На главную</a>
      </div>
    </main>
  );
}
